import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_2 = ["href", "data-dp-tooltip"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "visibility", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["data-dp-tooltip"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(_ctx.contentPreview.name), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.contentPreview.preview_key), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.contentPreview.status.description), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.validityPeriod), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.previewPath)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.previewPath,
              target: "_blank",
              class: "btn btn-icon btn-primary ms-2",
              "data-dp-tooltip": _ctx.$t('preview')
            }, _hoisted_4, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.previewPath)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-icon btn-primary ms-2",
              "data-dp-tooltip": _ctx.$t('copy'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPreviewLink && _ctx.copyPreviewLink(...args)))
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.contentPreview.replacement_cb_page_id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: {name: 'edit-content-preview-wysiwyg', params: {id: _ctx.contentPreview.replacement_cb_page_id}},
              class: "btn btn-icon btn-primary ms-2",
              "data-dp-tooltip": _ctx.$t('edit')
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["to", "data-dp-tooltip"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}